// extracted by mini-css-extract-plugin
export var description = "StrapiRichList-module--description--04fac";
export var hasTextWeightBold = "StrapiRichList-module--has-text-weight-bold--8acf6";
export var hasTextWeightLight = "StrapiRichList-module--has-text-weight-light--e5f22";
export var isUppercase = "StrapiRichList-module--is-uppercase--f4790";
export var list = "StrapiRichList-module--list--469b9";
export var listItem = "StrapiRichList-module--listItem--ce143";
export var listItemContent = "StrapiRichList-module--list-item-content--a5431";
export var listItemMarker = "StrapiRichList-module--list-item-marker--749c8";
export var listItemRichText = "StrapiRichList-module--list-item-rich-text--a9de2";
export var root = "StrapiRichList-module--root--375ba";